<script setup lang="ts">
withDefaults(defineProps<{ tone?: 'neutral' | 'success' | 'warning' | 'danger' }>(), { tone: 'neutral' })
</script>

<template>
  <span class="tq-badge" :class="`tq-badge--${tone}`"><slot /></span>
</template>

<style scoped>
.tq-badge { display: inline-flex; border: 1px solid transparent; border-radius: var(--tq-radius-pill); padding: 0.25rem 0.55rem; font-size: 0.72rem; font-weight: 700; letter-spacing: 0.04em; }
.tq-badge--neutral { border-color: var(--tq-border); background: var(--tq-bg-muted); color: var(--tq-text-muted); }
.tq-badge--success { border-color: color-mix(in oklch, var(--tq-success-readable) 28%, var(--tq-border)); background: var(--tq-success-bg); color: var(--tq-success-readable); }
.tq-badge--warning { border-color: color-mix(in oklch, var(--tq-color-orange) 30%, var(--tq-border)); background: var(--tq-warning-bg); color: var(--tq-orange-readable); }
.tq-badge--danger { border-color: color-mix(in oklch, var(--tq-danger-readable) 28%, var(--tq-border)); background: var(--tq-danger-bg); color: var(--tq-danger-readable); }
</style>
